import './CompareWorkshops.css';
import CompareWorkshopsRow from './CompareWorkshopsRow';
import CompareWorkshopsRowImage from './CompareWorkshopsRowImage';
import CompareWorkshopsPublicationAnalysisRow from './CompareWorkshopsPublicationAnalysisRow';

const CompareWorkshopsActivity1 = ({ comparedWorkshops, comparedWorkshopDetails }) => {
    
    return (
        <div className='mb-6'>            
            <CompareWorkshopsRowImage
                title="Common-theme radar: soil health challenges"
                titleBadge="Comparable across all workshops"
                imgPath="/activity_1/radar_chart_soil_health_and_management.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <div className="publication-analysis-context-note">
                <span className="tag is-light">Two complementary views</span>
                <p>
                    The common-theme radar uses the same broad theme vocabulary for every workshop, making cross-region comparison easier. The land-use-specific radar uses themes derived from workshops in the same land-use context, making it more precise for each workshop but less directly comparable across different land uses.
                </p>
            </div>
            <CompareWorkshopsPublicationAnalysisRow
                title="Land-use-specific radar: soil health challenges"
                titleBadge="Specific to this land use"
                diagramKey="challenges"
                comparedWorkshops={comparedWorkshops}
            />
            <CompareWorkshopsRowImage
                title="Word cloud"
                imgPath="/activity_1/wordcloud.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRowImage
                title="Topic mapping"
                imgPath="/activity_1/2D-predefined_categories.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRowImage
                title="Topic discovery"
                imgPath="/activity_1/2D-discovered_topics.png"
                property=""
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <div className='columns'>
                <div className='column'>
                    <h2 className='title is-5 has-text-centered'>Challenges for soil health & soil management</h2>
                </div>
            </div>
            <CompareWorkshopsRow
                title="Land management"
                property="reports.text_activity_1_soil_challenges_land_mgmt"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Societal"
                property="reports.text_activity_1_soil_challenges_social"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Environmental"
                property="reports.text_activity_1_soil_challenges_environment"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Political"
                property="reports.text_activity_1_soil_challenges_political"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Economical"
                property="reports.text_activity_1_soil_challenges_economical"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Technological"
                property="reports.text_activity_1_soil_challenges_technological"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Research"
                property="reports.text_activity_1_soil_challenges_research"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />            
        </div>
    );
};

export default CompareWorkshopsActivity1;
